import * as R from "ramda"
import React from "react"

import Gif from "./Gif"
import Image from "./Image"
import Mux from "./Mux"
import Video from "./Video"
import Wistia from "./Wistia"
import YouTube from "./YouTube"

export enum MediaTypes {
  Gif = "gif",
  Image = "image",
  Mux = "mux",
  Video = "video",
  Wistia = "wistia",
  YouTube = "youtube",
}

const components = {
  [MediaTypes.Gif]: Gif,
  [MediaTypes.Image]: Image,
  [MediaTypes.Mux]: Mux,
  [MediaTypes.Video]: Video,
  [MediaTypes.Wistia]: Wistia,
  [MediaTypes.YouTube]: YouTube,
}

const propsList = {
  [MediaTypes.Gif]: ["caption", "mobileGif", "gif"],
  [MediaTypes.Image]: ["caption", "fullWidth", "mobileImage", "image"],
  [MediaTypes.Mux]: ["caption", "muxVideo", "muxMobileVideo", "autoplayVideo"],
  [MediaTypes.Video]: [
    "caption",
    "youtubeVideoId",
    "mobileVideoUrl",
    "videoUrl",
    "videoThumbnail",
    "customVideoThumbnail",
    "autoplayVideo",
  ],
  [MediaTypes.Wistia]: ["caption", "wistiaVideoId", "autoplayVideo"],
  [MediaTypes.YouTube]: ["caption", "youtubeVideoId"],
}

interface MediaProps {
  autoplayVideo?: boolean
  blockId?: string
  caption?: string
  customVideoThumbnail?: string
  fullWidth?: boolean
  gif?: string
  image?: string
  mobileGif?: string
  mobileImage?: string
  mobileVideoUrl?: string
  muxMobileVideo?: {
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
  muxVideo?: {
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
  type: MediaTypes
  videoThumbnail?: string
  videoUrl?: string
  wistiaVideoId?: string
  youtubeVideoId?: string
}

const Media: React.FC<MediaProps> = (props) => {
  const { type } = props
  const Component = components[type]
  const componentProps = R.pick(propsList[type], props) as any
  return <Component blockId={props.blockId} {...componentProps} />
}

export default Media
